module.exports = __webpack_public_path__ + "img/icon_5_49.86f5cdf5.png";